var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-445.000000, -510.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Share",
    transform: "translate(445.000000, 510.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.54,23.46 C29.44,24.37 30,25.62 30,27 C30,28.38 29.44,29.63 28.54,30.54 C27.63,31.44 26.38,32 25,32 C22.24,32 20,29.76 20,27 C20,26.6 20.05,26.21 20.14,25.83 L11.26,20.79 C10.38,21.55 9.24,22 8,22 C5.24,22 3,19.76 3,17 C3,15.62 3.56,14.37 4.46,13.46 C5.37,12.56 6.62,12 8,12 C9.13,12 10.17,12.37 11,13 L20.3,6.72 C20.11,6.18 20,5.6 20,5 C20,3.62 20.56,2.37 21.46,1.46 C22.37,0.56 23.62,0 25,0 C26.38,0 27.63,0.56 28.54,1.46 C29.44,2.37 30,3.62 30,5 C30,6.38 29.44,7.63 28.54,8.54 C27.63,9.44 26.38,10 25,10 C23.93,10 22.94,9.67 22.13,9.1 L12.75,15.43 C12.91,15.93 13,16.45 13,17 C13,17.43 12.95,17.84 12.84,18.24 L21.68,23.26 C22.57,22.481 23.73,22 25,22 C26.38,22 27.63,22.56 28.54,23.46",
    id: 238
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionShare);
export default __webpack_public_path__ + "static/media/navigation-and-action-share.6be577e3.svg";
export { ForwardRef as ReactComponent };